import { render, staticRenderFns } from "./FlowImport.vue?vue&type=template&id=a82fe554"
import script from "./FlowImport.vue?vue&type=script&lang=js"
export * from "./FlowImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports